import { API_URL } from '@funnels/constants';
import { Lender } from '@funnels/types';
import { datadogUtil } from '@funnels/utils';

import { axios } from './axios';

function defaultFilter(lender: Lender, query: string) {
  const { name, shortName } = lender;
  query = query.toLowerCase();
  return name.toLowerCase().startsWith(query) || shortName.toLowerCase().startsWith(query);
}

export function searchLenders(query?: string, filter = defaultFilter) {
  return axios
    .get<Lender[]>(`${API_URL}/v1/lists/lenders`)
    .then((res) => {
      if (!query) {
        return res.data;
      }
      return res.data.filter((lender) => filter(lender, query));
    })
    .catch((err) => {
      datadogUtil.addError(err);
      return [];
    });
}
